(function () {

    angular
        .module('ngmvac')
        .directive('promoPopover', PromoPopover); 

        PromoPopover.$inject = ['$compile'];

        function PromoPopover(compile) {
            return {
                restrict: 'A',
                template: '<span><i class="fa fa-gift gift-orange" aria-hidden="true"></i> Promociones</span>',
                scope: {
                    package: '<'
                },
                link: function (scope, element, attrs) {
                    
                    var template = '<div><div class="promo-content" ng-repeat="room in package.rooms" ng-if="room.promotions"><div class="promo-room">{{room.roomName}}</div><div ng-repeat="promotion in room.promotions" class="item-promotion"><i class="fa fa-gift"></i> {{promotion.name}}</div></div></div>';
                    var templateCompiled = compile(template)(scope);
                    
                    element.popover({
                        trigger: 'hover',
                        html: true, 
                        content: templateCompiled,
                        placement: 'right'
                    });
                }
            };
        }

})();